


<section [class]="'mx-auto px-4 sm:px-6 lg:px-0 bg-white ' + dir">
    <section class="lg:container lg:mx-auto py-5 lg:px-8 lg:pb-8">
        <h2 class="text-center lg:text-4xl text-2xl font-semibold mb-7 mt-7">{{"ADV.FUTURE"|translate}}<br>{{"ADV.FUTURE1"|translate}} </h2>
        <section class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10 2xl:gap-16 py-5 gap-4">
            <div
                class="mb-2 border drop-shadow-lg border-white shadow-md hover:shadow-md rounded-xl  hover:cursor-pointer hover:rounded-xl  p-3 2xl:p-6">
                <figure class="py-2">
                    <app-webp-image src="../../../../assets/img_eco_friendly.png" alt="icon" />
                </figure>
                <h2 class="2xl:font-semibold 2xl:text-2xl  text-xl text-black py-5">{{"ADV.ECOHEAD"|translate}}</h2>
                <p class="text-gray-900 2xl:text-xl">{{"ADV.ECOCONTENT"|translate}}</p>
            </div>
            <div
                class="mb-2 border drop-shadow-lg border-white hover:shadow-md  hover:cursor-pointer hover:rounded-xl  p-3 2xl:p-6">
                <figure class="py-2">
                    <app-webp-image src="../../../../assets/img_cost_effective.png" alt="icon" />
                </figure>
                <h2 class="2xl:font-semibold 2xl:text-2xl text-xl text-black py-5">{{"ADV.COSTHEAD"|translate}}</h2>
                <p class="text-gray-900 2xl:text-xl">{{"ADV.COSTCONTENT"|translate}}</p>
            </div>
            <div
                class="mb-2 border drop-shadow-lg border-white hover:shadow-md  hover:cursor-pointer hover:rounded-xl  p-3 2xl:p-6">
                <figure class="py-2">
                    <app-webp-image src="../../../../assets/img_enhanced_networking.png" alt="icon" />
                </figure>
                <h2 class="2xl:font-semibold 2xl:text-2xl text-xl text-black py-5">{{"ADV.ENHANCED"|translate}}</h2>
                <p class="text-gray-900 2xl:text-xl">{{"ADV.ENHANCEDCONTENT"|translate}}</p>
            </div>
            <div
                class="mb-2 border drop-shadow-lg border-white hover:shadow-md  hover:cursor-pointer hover:rounded-xl  p-3 2xl:p-6">
                <figure class="py-2">
                    <app-webp-image src="../../../../assets/img_increased_engagements.png" alt="icon" />
                </figure>
                <h2 class="2xl:font-semibold 2xl:text-2xl text-xl text-black py-5">{{"ADV.INCREASED"|translate}}</h2>
                <p class="text-gray-900 2xl:text-xl">{{"ADV.INCREASEDCONTENT"|translate}}</p>
            </div>
        </section>
    </section>
</section>